import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export const CostSection = () => {
  return <section className="py-16 px-4 bg-gray-900" data-id="element-74">
      <div className="max-w-3xl mx-auto" data-id="element-75">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-76">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-77">
            ⚖️ EL COSTO DE NO TENER UN SISTEMA
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto rounded-full" data-id="element-78"></div>
        </motion.div>

        <div className="bg-black border border-red-900/50 rounded-2xl p-6 md:p-8 mb-8" data-id="element-79">
          <ul className="space-y-6" data-id="element-80">
            <li className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4" data-id="element-81">
              <span className="text-gray-400 font-medium md:w-1/2" data-id="element-82">
                Delivery de emergencia 2-3 veces por semana
              </span>
              <span className="hidden md:block text-red-500" data-id="element-83">→</span>
              <span className="text-white font-bold md:w-1/2" data-id="element-84">
                Miles de pesos al mes tirados
              </span>
            </li>
            <li className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4" data-id="element-85">
              <span className="text-gray-400 font-medium md:w-1/2" data-id="element-86">
                30 minutos diarios decidiendo qué cocinar
              </span>
              <span className="hidden md:block text-red-500" data-id="element-87">→</span>
              <span className="text-white font-bold md:w-1/2" data-id="element-88">
                180 horas al año perdidas
              </span>
            </li>
            <li className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4" data-id="element-89">
              <span className="text-gray-400 font-medium md:w-1/2" data-id="element-90">
                Siempre las mismas comidas
              </span>
              <span className="hidden md:block text-red-500" data-id="element-91">→</span>
              <span className="text-white font-bold md:w-1/2" data-id="element-92">
                Familia aburrida y sin ganas de comer en casa
              </span>
            </li>
            <li className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4" data-id="element-93">
              <span className="text-gray-400 font-medium md:w-1/2" data-id="element-94">
                Compras sin lista ni plan
              </span>
              <span className="hidden md:block text-red-500" data-id="element-95">→</span>
              <span className="text-white font-bold md:w-1/2" data-id="element-96">
                Desperdicio de comida y plata
              </span>
            </li>
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-97">
          <p className="text-3xl md:text-4xl font-extrabold text-white" data-id="element-98">
            Un solo pago.{' '}
            <span className="text-orange-500" data-id="element-99">Un sistema para siempre.</span>
          </p>
        </motion.div>
      </div>
    </section>;
};